<template>
    <div>
        <div v-if="mostrarTitulo" class="caption font-weight-bold material">{{nombre}}</div>

        <v-text-field persistent-hint v-for="(impacto, i) in impactos.slice(0, -1)" :key="i"
                      v-model="impactosSolCons[impacto.codigo]"
                      :hint="impacto.nombre" type="number"
                      required :suffix="impacto.unidades">
        </v-text-field>
    </div>
</template>

<script>
    export default {
        name: "ImpactosComponente",
        props: {
            nombre: {type: String, required: true},
            impactos: {type: Array, required: true},
            impactosSolCons: {type: Object, required: true},
            mostrarTitulo: {type: Boolean, required: false, default: true},
        }
    }
</script>

<style scoped>
    .material {
        font-size: 18px !important;
        color: #40108e !important;
        font-weight: 700 !important;
    }
</style>